"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.environment = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// entries in development | test | production will override matching entries in default
var configuration = {
  default: {
    REACT_APP_DATADOG_CLIENT_TOKEN: 'pub6b41c9614b8dd3e0aa03a09f243f63cd',
    REACT_APP_DATADOG_APPLICATION_ID: '59f2f761-dc0e-46b0-8519-acbb3a27911d',
    REACT_APP_SERVICE: 'fi-connect',
    REACT_APP_VERSION: '0.6.2'
  },
  development: {
    BANK_CONNECT_API_URL: 'https://api.test.latitudefinancial.com/v1/bank-connect-service',
    PROVISO_API_URL: 'https://test.bankstatements.com.au/api/v1',
    PROVISO_IMAGES_BASE_URL: 'https://test.bankstatements.com.au/images/institutions'
  },
  test: {
    BANK_CONNECT_API_URL: 'https://api.test.latitudefinancial.com/v1/bank-connect-service',
    PROVISO_API_URL: 'https://test.bankstatements.com.au/api/v1',
    PROVISO_IMAGES_BASE_URL: 'https://test.bankstatements.com.au/images/institutions'
  },
  production: {
    BANK_CONNECT_API_URL: 'https://api.latitudefinancial.com/v1/bank-connect-service',
    PROVISO_API_URL: 'https://bankstatements.com.au/api/v1',
    PROVISO_IMAGES_BASE_URL: 'https://bankstatements.com.au/images/institutions'
  }
};

var environment = function () {
  var instance = "production";
  return function (env) {
    if (env) {
      instance = env;
    }

    return instance;
  };
}();

exports.environment = environment;

var getEnvVar = function getEnvVar(id) {
  var env = environment();

  var config = _objectSpread(_objectSpread({}, configuration.default), configuration[env]);

  return config[id];
};

var _default = getEnvVar;
exports.default = _default;